import { Theme } from "@mui/material";

export const getNumberColor = (theme: Theme, number: number = 0): string => {
  if (number < 0) {
    return theme.palette.text.negative;
  }
  if (number > 0) {
    return theme.palette.text.positive;
  }
  return theme.palette.text.primary;
};
